import environment from 'modules/core/constants/environment';

export const isSandbox = () => ['sandbox', 'local'].includes(environment.ENV);
